window._navDesktop = function () {

    var mainNavEl = document.querySelector('.main-nav');
    if (!mainNavEl || mainNavEl === null || mainNavEl === undefined) {
        return;
    }

    var navDesktop_isMobile = !window.matchMedia('(min-width: 980px)').matches;
    var mainNavBtns = document.querySelectorAll('.main-nav .main-nav__list-item--top-level button:not(.main-nav__close-button)');
    var mainNavCloseBtns = document.querySelectorAll('.main-nav .main-nav__close-button');
    var allButtons = document.querySelectorAll('.main-nav button');
    var currentMainHoveredBtn;
    var insuranceTabHovered = false;
    var timer;
    var navOpen = false;

    document.addEventListener('DOMContentLoaded', function () {
        createDimmer();
    });

    mainNavEl.addEventListener('mouseleave', function () {
        if (!navOpen) { return; }
        setTimeout(function () {
            closeNav();
        }, 250);
    });

    // Set isMobile on browser resize
    window.addEventListener('resize', function () {
        if (window.matchMedia('(min-width: 980px)').matches) {
            navDesktop_isMobile = false;
        } else {
            navDesktop_isMobile = true;
            closeNav();
        }
    });

    document.body.addEventListener('keydown', function (event) {
        if (event.code === 'Tab' && !event.shiftKey) {
            setTimeout(function () {
                if (document.activeElement.closest('.main-nav') === null && navOpen) {
                    closeNav();
                }
            }, 0);
        }
    });

    document.querySelector('header').addEventListener('keydown', function (event) {
        if (navDesktop_isMobile) { return; }
        if (event.code === 'Tab' && !event.shiftKey) {
            if (document.activeElement.id === document.querySelector('[data-product="car-care-_-selling"] > button') && !mainNavEl.classList.contains('nav-product--carcare')) { // jshint ignore:line
                closeNav();
            } else if (document.activeElement === document.querySelector('[data-product="car-care-_-selling"] .main-nav__container--bottom-level .main-nav__close-button')) { // jshint ignore:line
                closeNav();
            }
        } else if (event.code === 'Tab' && event.shiftKey) {
            if (document.activeElement.classList.contains('logo')) {
                closeNav();
            }
        }
    });

    document.getElementById('skip-nav-link').addEventListener('click', function () {
        closeNav();
    });

    // Handles enter press to activate button clicks
    for (let i = 0; i < allButtons.length; i++) {
        allButtons[i].addEventListener('keypress', function (event) { // jshint ignore:line
            onEnterPress(event);
        });
    }

    // Handles close nav button
    for (let i = 0; i < mainNavCloseBtns.length; i++) {
        mainNavCloseBtns[i].addEventListener('click', function () { // jshint ignore:line
            closeNav();
        });
    }

    // Handles nav hover
    for (let i = 0; i < mainNavBtns.length; i++) {
        mainNavBtns[i].addEventListener('mouseenter', function (event) { // jshint ignore:line
            if (navDesktop_isMobile) { return; }
            timer = setTimeout(function () {
                onMainNavHover(event);
            }, 250);
        });
    }

    // This will clear the hover delay timer when the mouse leaves the inurance sub menu. Stops unwanted animations.
    for (let i = 0; i < mainNavBtns.length; i++) {
        mainNavBtns[i].addEventListener('mouseleave', function (event) { // jshint ignore:line
            if (event.target.classList.contains('delay-hover')) {
                clearTimeout(timer);
            }
        });
    }

    // Utility classes
    function removeOrAddClass(element, className, add) {
        if (navDesktop_isMobile) { return; }
        if (add) {
            element.forEach(function (el) {
                el.classList.add(className);
            });
        } else {
            element.forEach(function (el) {
                el.classList.remove(className);
            });
        }
    }

    // Get the button id and pass open the right secondary menu
    function onMainNavHover(event) {
        if (navDesktop_isMobile) { return; }
        currentMainHoveredBtn = event.target;
        document.querySelector('.nav-dimmer').classList.add('is-shown');
        toggleSecondaryMenu();
    }

    // Handles opening all sub menus, unless it is the insurance tab then this function will pass to handleInsuranceTabHovered();
    function toggleSecondaryMenu() {
        if (navDesktop_isMobile) { return; }
        if (navOpen && currentMainHoveredBtn.parentElement.dataset.product === 'insurance' && mainNavEl.classList.contains('nav-insurance')) {
            return;
        }
        navOpen = true;
        addNavClasses(currentMainHoveredBtn);
        if ((currentMainHoveredBtn.classList.contains('second-level-links--mobile') && currentMainHoveredBtn.classList.contains('main-nav__options--mid-level')) || currentMainHoveredBtn.parentElement.dataset.product === 'insurance') {
            // Insurance tab hovered, handle this separately.
            insuranceTabHovered = true;
            handleButtonActiveStates(currentMainHoveredBtn);
            handleInsuranceTabHovered();
            return;
        } else {
            insuranceTabHovered = false;
        }
        // Is not insurance tab that has been hovered.
        handleButtonActiveStates(currentMainHoveredBtn);
        var secondaryMenuToOpen = currentMainHoveredBtn.nextElementSibling.nextElementSibling;
        if (!secondaryMenuToOpen) { return; }
        var alreadyOpenSecondaryMenu = document.querySelectorAll('.main-nav .nav--is-open');
        if (alreadyOpenSecondaryMenu.length) {
            removeOrAddClass(alreadyOpenSecondaryMenu, 'nav--is-open', false);
        }
        secondaryMenuToOpen.classList.add('nav--is-open');
    }

    function addNavClasses(currentMainHoveredBtn) {
        if (navDesktop_isMobile) { return; }
        var navClassName = '';
        var insuranceClassname = 'nav-insurance';
        mainNavEl.className = 'main-nav';
        switch (true) {
            case (currentMainHoveredBtn.parentElement.dataset.product === 'insurance'):
                navClassName = 'nav-product--motor';
                break;
            case (currentMainHoveredBtn.parentElement.dataset.product === 'utilities'):
                navClassName = 'nav-product--utilities';
                break;
            case (currentMainHoveredBtn.parentElement.dataset.product === 'finance'):
                navClassName = 'nav-product--finance';
                break;
            case (currentMainHoveredBtn.parentElement.dataset.product === 'car-care-_-selling'):
                navClassName = 'nav-product--carcare';
                break;
            case (currentMainHoveredBtn.parentElement.dataset.subProduct === 'motor-primary'):
                navClassName = 'nav-product--motor';
                mainNavEl.classList.add(insuranceClassname);
                break;
            case (currentMainHoveredBtn.parentElement.dataset.subProduct === 'home'):
                navClassName = 'nav-product--home';
                mainNavEl.classList.add(insuranceClassname);
                break;
            case (currentMainHoveredBtn.parentElement.dataset.subProduct === 'life'):
                navClassName = 'nav-product--life';
                mainNavEl.classList.add(insuranceClassname);
                break;
            case (currentMainHoveredBtn.parentElement.dataset.subProduct === 'travel'):
                navClassName = 'nav-product--travel';
                mainNavEl.classList.add(insuranceClassname);
                break;
            case (currentMainHoveredBtn.parentElement.dataset.subProduct === 'pet'):
                navClassName = 'nav-product--pet';
                mainNavEl.classList.add(insuranceClassname);
                break;
            case (currentMainHoveredBtn.parentElement.dataset.subProduct === 'business-primary'):
                navClassName = 'nav-product--business';
                mainNavEl.classList.add(insuranceClassname);
                break;
        }
        mainNavEl.classList.add(navClassName);
    }

    // Handles adding classes to show that a button is active
    function handleButtonActiveStates(button) {
        if (navDesktop_isMobile) { return; }
        var isMainInsuranceBtn = button.parentElement.dataset.product === 'insurance';
        if (isMainInsuranceBtn && mainNavEl.classList.contains('nav-insurance')) {
            return;
        }
        if (document.querySelector('.main-nav .main-nav__container--mid-level--ul .nav--btn-is-active') && isMainInsuranceBtn) {
            // This stops active menu button changing when user is in insurance tab and hovers back over the main insurance button
            return;
        }
        var activeButtons = document.querySelectorAll('.main-nav .nav--btn-is-active');
        removeOrAddClass(activeButtons, 'nav--btn-is-active', false);
        if (insuranceTabHovered && isMainInsuranceBtn) {
            // Main insurance button hovered
            removeOrAddClass([document.querySelector('[data-sub-product="motor-primary"] > button'), button], 'nav--btn-is-active', true); // jshint ignore:line
            return;
        } else if (insuranceTabHovered && !isMainInsuranceBtn) {
            // Insurance mid-level option hovered
            document.querySelector('[data-product="insurance"] button').classList.add('nav--btn-is-active'); // jshint ignore:line
        }
        button.classList.add('nav--btn-is-active');
    }

    // Opens the correct menus when the insurance tab is hovered. Insurance has an extra menu so needs to be treated slightly different.
    function handleInsuranceTabHovered() {
        if (navDesktop_isMobile) { return; }
        var isMainInsuranceBtn = currentMainHoveredBtn.parentElement.dataset.product === 'insurance';
        var insuranceMidLevelMenu = document.querySelector('[data-product="insurance"] .main-nav__container--mid-level'); // jshint ignore:line
        if (isMainInsuranceBtn) {
            var isOpenMenus = document.querySelectorAll('.main-nav .nav--is-open');
            if (isOpenMenus.length) {
                removeOrAddClass(isOpenMenus, 'nav--is-open', false);
            }
            var motorBottomMenu = document.querySelector('[data-sub-product="motor-primary"] .main-nav__container--bottom-level'); // jshint ignore:line
            removeOrAddClass([insuranceMidLevelMenu, motorBottomMenu], 'nav--is-open', true);
        } else {
            var menuToClose = insuranceMidLevelMenu.querySelector('.nav--is-open');
            var menuToOpen = insuranceMidLevelMenu.querySelector('.nav--btn-is-active').nextElementSibling;
            menuToClose.classList.remove('nav--is-open');
            menuToOpen.classList.add('nav--is-open');
        }
    }

    function createDimmer() {
        var dimmerElement = document.createElement('div');
        dimmerElement.setAttribute('class', 'nav-dimmer is-injected');
        document.body.appendChild(dimmerElement);
    }

    // Activates hover functions if user is using keyboard and has pressed enter on a menu option.
    function onEnterPress(event) {
        if (navDesktop_isMobile) { return; }
        if (event.key === 'Enter') {
            onMainNavHover(event);
        }
    }

    // Closes nav on close nav button click
    function closeNav() {
        if (navDesktop_isMobile) { return; }
        var allOpenMenus = document.querySelectorAll('.main-nav .nav--is-open');
        var allActiveButtons = document.querySelectorAll('.main-nav .nav--btn-is-active');
        removeOrAddClass(allOpenMenus, 'nav--is-open', false);
        removeOrAddClass(allActiveButtons, 'nav--btn-is-active', false);
        document.querySelector('.nav-dimmer').classList.remove('is-shown');
        navOpen = false;
    }

    return {
        closeNav: closeNav
    };
}();